import Link from 'next/link'
import type { HTMLAttributeAnchorTarget, MouseEventHandler, ReactNode } from 'react'

export const TextLink = ({
  children,
  href = '#',
  onClick,
  className,
  prefetch = false,
  target,
  rel,
}: TextLinkProps) => (
  <Link
    className={`underline text-vi-red cursor-pointer hover:no-underline ${className || ''}`}
    href={href}
    onClick={onClick}
    prefetch={prefetch}
    target={target}
    rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)}
  >
    {children}
  </Link>
)

interface TextLinkProps {
  children: ReactNode
  href?: string
  className?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
  prefetch?: boolean
  target?: HTMLAttributeAnchorTarget
  rel?: string
}
